import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hydrateUser } from '../../store/slices/authSlice';
import AntLoader from '../layout/loading/AntLoader/AntLoader';

export default function AuthGate({ children }) {
  const dispatch = useDispatch();
  const { init } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(hydrateUser());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (init) {
    return children;
  }

  return <AntLoader />;
}
